export default "__VITE_ASSET__CBpncyQU__"